import { c as _c } from "react/compiler-runtime";
import type { ArtifactVersion } from '@onefootprint/request-types/dashboard';
import { Dialog } from '@onefootprint/ui';
import { formatDistanceToNow } from 'date-fns';
import { useTranslation } from 'react-i18next';
import useActorLabel from '@/hooks/use-actor-label';
type VersionsHistoryDialogProps = {
  open: boolean;
  onClose: () => void;
  versions: ArtifactVersion[];
  onSelectVersion?: (versionId: string) => void;
};
const VersionsHistoryDialog = t0 => {
  const $ = _c(14);
  const {
    open,
    onClose,
    versions,
    onSelectVersion
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "versionsHistory"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("artifact", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClose || $[4] !== onSelectVersion) {
    t3 = onSelectVersion ? versionId => {
      onSelectVersion(versionId);
      onClose();
    } : undefined;
    $[3] = onClose;
    $[4] = onSelectVersion;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3 || $[7] !== versions) {
    t4 = <VersionsList versions={versions} onSelectVersion={t3} />;
    $[6] = t3;
    $[7] = versions;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== onClose || $[10] !== open || $[11] !== t2 || $[12] !== t4) {
    t5 = <Dialog title={t2} open={open} onClose={onClose} size="compact" noPadding={true}>{t4}</Dialog>;
    $[9] = onClose;
    $[10] = open;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};

// The version rows. Exposed so stories can render them inline (the Dialog itself
// is a portal modal, which can't be shown side-by-side in a gallery snapshot).
type VersionsListProps = {
  versions: ArtifactVersion[];
  onSelectVersion?: (versionId: string) => void;
};
export const VersionsList = t0 => {
  const $ = _c(12);
  const {
    versions,
    onSelectVersion
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "versionsHistory"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("artifact", t1);
  const getActorLabel = useActorLabel();
  let t2;
  if ($[1] !== getActorLabel || $[2] !== onSelectVersion || $[3] !== t || $[4] !== versions) {
    let t3;
    if ($[6] !== getActorLabel || $[7] !== onSelectVersion || $[8] !== t) {
      t3 = (version, index) => {
        const {
          id,
          versionNumber,
          createdAt,
          createdByActor
        } = version;
        const isCurrent = index === 0;
        const canSelectVersion = !isCurrent && !!onSelectVersion;
        const content = <><div className="flex flex-wrap items-center justify-between w-full gap-x-3 gap-y-1 md:flex-nowrap md:gap-3"><div className="flex items-center gap-3 min-w-0"><span className="text-label-2 text-primary shrink-0">{t(_temp2, {
                  versionNumber
                })}</span>{isCurrent && <span className="inline-flex items-center px-2 py-1 rounded-full bg-info text-info text-caption-1 shrink-0">{t(_temp3)}</span>}</div><span className="text-body-3 text-tertiary shrink-0">{formatDistanceToNow(createdAt, {
                addSuffix: true
              })}</span></div><p className="text-body-3 text-tertiary line-clamp-3">{t(_temp4)} {getActorLabel(createdByActor)}</p></>;
        return canSelectVersion ? <button key={id} type="button" onClick={() => onSelectVersion?.(id)} className="w-full text-left border border-tertiary rounded-default bg-primary p-3 flex flex-col gap-1 transition-colors cursor-pointer hover:bg-hover">{content}</button> : <div key={id} className="w-full text-left px-1 py-2 flex flex-col gap-1 border-b border-tertiary last:border-b-0">{content}</div>;
      };
      $[6] = getActorLabel;
      $[7] = onSelectVersion;
      $[8] = t;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = versions.map(t3);
    $[1] = getActorLabel;
    $[2] = onSelectVersion;
    $[3] = t;
    $[4] = versions;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[10] !== t2) {
    t3 = <div className="p-4 md:p-6 flex flex-col gap-3">{t2}</div>;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default VersionsHistoryDialog;
function _temp($) {
  return $.title;
}
function _temp2($) {
  return $.versionNumber;
}
function _temp3($_0) {
  return $_0.current;
}
function _temp4($_1) {
  return $_1.actorPrefix;
}